import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import fileDownload from 'js-file-download';

export const findCapital = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/capital`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/capital', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pj_information/capital`);
    })
}

export const useFindCapital = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findCapital(data),
    });
}

export const findAdditionalInformation = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/additional_information`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/additional_information', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pj_information/additional_information`);
    })
}

export const useFindAdditionalInformation = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findAdditionalInformation(data),
    });
}


export const findLegalComplianceCheck = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/legalComplianceCheck`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/legalComplianceCheck', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pj_information/legalComplianceCheck`);
    })
}

export const useFindLegalComplianceCheck = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findLegalComplianceCheck(data),
    });
}
export const findPDFLegalComplianceCheck = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/pdf/legalComplianceCheck`,
        {
            identifier: data.identifier
        },
        {
            responseType: 'blob'
        }
    ).then((response) => {
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
            const reader = new FileReader();
            return new Promise((_, reject) => {
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result as string);
                        reject(new Error(errorJson.message || "Error al procesar el PDF"));
                    } catch (e) {
                        reject(new Error("Respuesta no válida"));
                    }
                };
                reader.readAsText(response.data);
            });
        }

        fileDownload(response.data, `Cumplimiento-Obligaciones-${data.identifier}.pdf`);
        return response.data;

    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/legalComplianceCheck', undefined, data?.msj);
        getError(
            error,
            error?.response?.data?.message
                ? error?.response?.data?.message
                : `Error service: /pj_information/legalComplianceCheck`
        );
    });
};

export const useFindPDFLegalComplianceCheck = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPDFLegalComplianceCheck(data),
    });
}

export const findEconomicActivation = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/tax_payer/economicActivity`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/tax_payer/economicActivity', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /tax_payer/economicActivity`);
    })
}

export const useFindEconomicActivation = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findEconomicActivation(data),
    });
}

export const findContact = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/tax_payer/contact`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/tax_payer/contact', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /tax_payer/contact`);
    })
}

export const useFindContact = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findContact(data),
    });
}

export const findLocations = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/tax_payer/establishmentAddresses`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/tax_payer/establishmentAddresses', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /tax_payer/establishmentAddresses`);
    })
}

export const useFindLocations = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findLocations(data),
    });
}
